import { render } from "./AddEditSettings.vue?vue&type=template&id=1610e3ea&scoped=true"
import script from "./AddEditSettings.vue?vue&type=script&lang=js"
export * from "./AddEditSettings.vue?vue&type=script&lang=js"

import "./AddEditSettings.vue?vue&type=style&index=0&id=1610e3ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1610e3ea"]])

export default __exports__